import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSecureDataSettings } from 'services/secureDataSharing';
export const ThunkGetSecureDataSharing = createAsyncThunk(
  'secureDataSharing/getSecureDataSettings',
  () => getSecureDataSettings().then(r => r.data),
);
